import { contactConfig, headerLayout } from '../../config.js'
import { isMobile } from '../base'

function createHeaderIcons() {
    const navigationButtons = $('.navigation-buttons')
    $('.top-navigation-tools .top-nav-button').prependTo(navigationButtons)
}
function moveCartWidget() {
    const widgetsClones = $('.user-action-in').clone()
    widgetsClones.find('.login-widget').remove()
    widgetsClones.appendTo('.header-top-wrapper')
}

// obecná funkce, která shromažďuje všechny funkce, které elementy do hlavičky přidávají nebo někam přesunují
function moveAddHeaderElements() {
    createHeaderIcons()
    moveCartWidget()

    $('.site-msg').insertBefore('.top-navigation-bar')

    languagesMenu()
}

function languagesMenu() {
    const currentSite = window.location.hostname
    let currentLang = 'cz'

    if (currentSite.includes('.pl')) {
        currentLang = 'pl'
    } else if (currentSite.includes('.sk')) {
        currentLang = 'sk'
    }

    // Language data configuration
    const languages = {
        pl: {
            code: 'PL',
            name: 'Język polski',
            url: 'https://www.swietneceny.pl/',
        },
        cz: {
            code: 'CZ',
            name: 'Čeština',
            url: 'https://www.vsevyhodne.cz/',
        },
        sk: {
            code: 'SK',
            name: 'Slovenčina',
            url: 'https://www.vsetkovyhodne.sk/',
        },
    }

    // SVG definitions for all flags
    const svgDefs = `<svg aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><symbol id="shp-flag-PL" viewBox="0 0 32 32"><title>PL</title><path fill="#f0f0f0" style="fill: var(--color21, #f0f0f0)" d="M0 5.334h32v21.333h-32v-21.333z"></path><path fill="#f0f0f0" style="fill: var(--color21, #f0f0f0)" d="M0 5.334h32v10.666h-32v-10.666z"></path><path fill="#d80027" style="fill: var(--color19, #d80027)" d="M0 16h32v10.666h-32v-10.666z"></path></symbol><symbol id="shp-flag-CZ" viewBox="0 0 32 32"><title>CZ</title><path fill="#0052b4" style="fill: var(--color20, #0052b4)" d="M0 5.334h32v21.333h-32v-21.333z"></path><path fill="#d80027" style="fill: var(--color19, #d80027)" d="M32 16v10.666h-32l13.449-10.666z"></path><path fill="#f0f0f0" style="fill: var(--color21, #f0f0f0)" d="M32 5.334v10.666h-18.551l-13.449-10.666z"></path></symbol><symbol id="shp-flag-SK" viewBox="0 0 32 32"><title>SK</title><path fill="#f0f0f0" style="fill: var(--color21, #f0f0f0)" d="M0 5.334h32v21.333h-32v-21.333z"></path><path fill="#0052b4" style="fill: var(--color20, #0052b4)" d="M0 12.29h32v7.42h-32v-7.42z"></path><path fill="#d80027" style="fill: var(--color19, #d80027)" d="M0 19.71h32v6.957h-32v-6.956z"></path><path fill="#f0f0f0" style="fill: var(--color21, #f0f0f0)" d="M8.092 11.362v5.321c0 3.027 3.954 3.954 3.954 3.954s3.954-0.927 3.954-3.954v-5.321h-7.908z"></path><path fill="#d80027" style="fill: var(--color19, #d80027)" d="M9.133 11.518v5.121c0 0.342 0.076 0.665 0.226 0.968 1.493 0 3.725 0 5.373 0 0.15-0.303 0.226-0.626 0.226-0.968v-5.121h-5.826z"></path><path fill="#f0f0f0" style="fill: var(--color21, #f0f0f0)" d="M13.831 15.089h-1.339v-0.893h0.893v-0.893h-0.893v-0.893h-0.893v0.893h-0.893v0.893h0.893v0.893h-1.339v0.893h1.339v0.893h0.893v-0.893h1.339z"></path><path fill="#0052b4" style="fill: var(--color20, #0052b4)" d="M10.577 18.854c0.575 0.361 1.166 0.571 1.469 0.665 0.303-0.093 0.894-0.303 1.469-0.665 0.58-0.365 0.987-0.782 1.218-1.246-0.255-0.18-0.565-0.286-0.901-0.286-0.122 0-0.241 0.015-0.355 0.041-0.242-0.55-0.791-0.934-1.43-0.934s-1.188 0.384-1.43 0.934c-0.114-0.027-0.233-0.041-0.355-0.041-0.336 0-0.646 0.106-0.901 0.286 0.231 0.465 0.637 0.882 1.217 1.246z"></path></symbol></defs></svg>`

    // Create language list items (excluding current language)
    let languageListItems = ''
    Object.keys(languages).forEach((lang) => {
        if (lang !== currentLang) {
            const langInfo = languages[lang]
            languageListItems += `
                <li>
                    <a href="${langInfo.url}" rel="nofollow" class="languagesMenu__list__link">
                        <svg class="shp-flag shp-flag-${langInfo.code}">
                            <use xlink:href="#shp-flag-${langInfo.code}"></use>
                        </svg>
                        <span class="languagesMenu__list__name">${langInfo.name}</span>
                    </a>
                </li>`
        }
    })

    // Current language info
    const currentLangInfo = languages[currentLang]

    // Build the complete menu HTML
    const menuHTML = `
    <div class="languagesMenu">
        <button id="topNavigationDropdown" class="languagesMenu__flags" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            ${svgDefs}
            <svg class="shp-flag shp-flag-${currentLangInfo.code}">
                <use xlink:href="#shp-flag-${currentLangInfo.code}"></use>
            </svg>
            <span class="caret"></span>
        </button>
        <div class="languagesMenu__content" aria-labelledby="topNavigationDropdown">
            <div class="languagesMenu__box toggle-window js-languagesMenu__box" data-hover="true" data-target="language">
                <div class="languagesMenu__header languagesMenu__header--name">Language</div>
                <div class="languagesMenu__header languagesMenu__header--actual" data-toggle="dropdown" aria-expanded="false">
                    <svg class="shp-flag shp-flag-${currentLangInfo.code}">
                        <use xlink:href="#shp-flag-${currentLangInfo.code}"></use>
                    </svg>
                    <span>${currentLangInfo.code}</span>
                    <span class="caret"></span>
                </div>
                <ul class="languagesMenu__list languagesMenu__list--language">
                    ${languageListItems}
                </ul>
            </div>
        </div>
    </div>`

    // Remove any existing language menu
    $('.languagesMenu').remove()

    // Insert the menu in the appropriate location
    if ($(window).width() < 768) {
        $('#navigation .menu-level-1').before(menuHTML)
    } else {
        $('.header-top .search').after(menuHTML)
    }
}

// Přidá třídu scrolled do body, pokud je uživatel scrolluje pro fungování fixní hlavičky
function addScrolledClass() {
    const mobileElements = [$('.site-msg.information')]

    const desktopElements = [$('.header-top'), $('.admin-bar'), $('.site-msg.information')]

    $(window).on('scroll', function () {
        const elements = isMobile() ? mobileElements : desktopElements

        const threshold = elements.reduce((sum, el) => {
            return sum + (el.is(':visible') ? el.outerHeight() || 0 : 0)
        }, 0)

        $('body').toggleClass('scrolled', $(this).scrollTop() > threshold)
    })
}

function addScrollDirectionClass() {
    let lastScrollTop = 0
    const window = $(window)
    const body = $('body')

    $(document).on('scroll', function () {
        const scrollTop = $(document).scrollTop()

        if (scrollTop > lastScrollTop) {
            body.removeClass('scrolled-up').addClass('scrolled-down')
        } else {
            body.removeClass('scrolled-down').addClass('scrolled-up')
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    })
}

function setSiteMsgHeightVar() {
    const siteMsgElement = $('.site-msg.information')
    const siteMsgHeight = siteMsgElement.length ? siteMsgElement.outerHeight() : 0

    document.documentElement.style.setProperty('--site-msg-height', `${siteMsgHeight}px`)

    $('.js-close-information-msg').on('click', function () {
        document.documentElement.style.setProperty('--site-msg-height', `0px`)
    })
}

function topNavigation() {
    $('.top-navigation-bar .container').append(
        $(`<span class="opening-hours">${contactConfig.openingHours}</span>`)
    )
}

function addContactToTopNavigation() {
    $('footer .contact-box').clone().appendTo('.top-navigation-bar .container')
}

export function initHeader() {
    shoptet.config.mobileHeaderVersion = '0'
    moveAddHeaderElements()
    addScrolledClass()
    addScrollDirectionClass()
    setSiteMsgHeightVar()

    if (!isMobile()) {
        addContactToTopNavigation()
        topNavigation()
    }

    document.addEventListener('resizeEnd', () => {
        setSiteMsgHeightVar()
    })
}
